import React from 'react';
import { ColumnItem } from '../column-item';
import { CommentEnd, CommentStart } from '../comments';
import { useConfig } from '../config-context';
export function Social(props) {
    const { padding, children } = props;
    const { renderComments } = useConfig();
    return (React.createElement(ColumnItem, { padding: padding, align: "center" }, renderComments ? (React.createElement(React.Fragment, null,
        React.createElement(CommentStart, null),
        React.createElement("table", { align: "center", border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation" },
            React.createElement("tr", null, React.Children.map(children, (child) => (React.createElement("td", null,
                React.createElement(CommentEnd, null),
                child,
                React.createElement(CommentStart, null)))))),
        React.createElement(CommentEnd, null))) : (children)));
}
//# sourceMappingURL=social.js.map